import {
  SET_LIST,
  SET_TOTAL,
  SET_SORT,
  SET_ORDER,
  CLEAR,
  CHANGE_ELEMENT,
} from "./mutation-types";

export default {
  setRootAssetId(state, id) {
    state.rootAssetId = id;
  },
  setMusicAssetId(state, id) {
    state.musicAssetId = id;
  },
  setParent(state, id) {
    state.parent = id;
  },
  setParentIsEncrypt(state, isEncrypt) {
    state.parentIsEncrypt = isEncrypt;
  },
  setParentSource(state, parentSource) {
    state.parentSource = parentSource;
  },
  [SET_LIST](state, listItems) {
    state["assets"] = [...listItems];
  },
  [CHANGE_ELEMENT](state, payload) {
    const elemList = state["assets"];
    elemList.splice(payload.index, 1, payload.newElem);
  },
  [SET_TOTAL](state, total) {
    state["total"] = total;
  },
  [SET_SORT](state, sort) {
    state["sort"] = sort;
  },
  [SET_ORDER](state, order) {
    state["order"] = order;
  },
  [CLEAR](state) {
    state["assets"] = [];
    state["total"] = 0;
    state["sort"] = "isLeaf";
    state["order"] = "ascending";
  },
};
